import { connect } from 'react-redux';

import MainMenuAdmin from '../components/MainMenuAdmin';
import storage from '../../../../lib/Storage';
import { findStorageType } from '../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  return {
    activeId: storage.get(findStorageType(), 'partnershipId'),
    accessAdmin: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
    isMenuAdminCollapsed: state.ui.get('isMenuAdminCollapsed'),
    partnershipName:
      storage.get(findStorageType(), 'partnershipData')?.name ?? null,
  };
};

const MainMenuAdminContainer = connect(mapStateToProps)(MainMenuAdmin);

export default MainMenuAdminContainer;
